function GoogleAnalytics(id) {
    loadScript();
    var gtag = createGtag();

    this.logPageView = function (pageName, userId, page) {
        if (userId) {
            gtag('set', 'user_id', userId);
        }

        gtag('event', 'pageview', {
            'title': pageName,
            'page': page || location.pathname
        });
    };

    function loadScript() {
        var gTagScript = document.createElement('script');
        var firstScript = document.getElementsByTagName('script')[0];

        gTagScript.async = true;
        gTagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
        firstScript.parentNode.insertBefore(gTagScript, firstScript);
    }

    function createGtag() {
        window.dataLayer = window.dataLayer || [];
        function gtag(){ dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', id, { 'debug_mode': true });

        return gtag;
    }
}
